import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { TypeUtils } from '@utils';
import { PortalRoutePath } from '@models';
import { easyInputService, User } from '@services';
import { loggedinUserSelector } from '@store/slices/common.slice';
import { useService } from '@hooks/useService';
import { LoadingLayout } from '@components/common';

export const Welcome: FC = () => {
	const loggedinUser = useSelector(loggedinUserSelector);
	const user = TypeUtils.convert(User, loggedinUser);
	const { data: applicable, loading } = useService(() => easyInputService.checkApplicable());

	if (loading) {
		return <LoadingLayout />;
	}

	if (user?.isAdmin()) {
		return <Navigate to={`../${PortalRoutePath.ORGANIZATIONS}`} replace />;
	} else if (user?.isDriver()) {
		return <Navigate to={`../${PortalRoutePath.VEHICLE_LIST}`} replace />;
	} else if (user?.isDealer()) {
		return <Navigate to={`../${PortalRoutePath.CLIENT_ACCOUNTS}`} replace />;
	} else if (user?.isFleetManager()) {
		return <Navigate to={`../${applicable ? PortalRoutePath.EASY_INPUT : PortalRoutePath.DASHBOARD}`} replace />;
	} else {
		return <Navigate to={`../${PortalRoutePath.DASHBOARD}`} replace />;
	}
};
